import React from 'react';
import {Avatar} from 'antd';

const columnDefines = () => ({
    avatar: {
        title: '姓名',
        dataIndex: 'avatar',
        render: (text, record) => (
            <>
                <Avatar src={record.avatar} />
                &nbsp;&nbsp;{record.name}&nbsp;&nbsp;({record.extId})
            </>
        ),
    },
    name: {
        title: '姓名',
        dataIndex: 'name',
    },
    email: {
        title: '邮箱',
        dataIndex: 'email',
    },
    mobile: {
        title: '电话',
        dataIndex: 'mobile',
    },
    position: {
        title: '职务',
        dataIndex: 'position',
    },
    directLeader: {
        title: '直属上级',
        dataIndex: 'directLeader',
    },
});

export function getColumns(keys) {
    const defines = columnDefines();
    return keys.map(key => defines[key]).filter(Boolean);
}
